import React, { useState } from 'react';
import { getUILoc } from '../utils/cardUtils.js';
import '../App.css';

const NumberInput = ({ prompt, min, max, onConfirm, isClosing }) => {
    const [value, setValue] = useState(min);
    const [isFocused, setIsFocused] = useState(false);

    const handleIncrement = () => {
        setValue(prev => Math.min(max, prev + 1));
    };

    const handleDecrement = () => {
        setValue(prev => Math.max(min, prev - 1));
    };

    const handleChange = (e) => {
        const inputValue = e.target.value;
        if (inputValue === '') {
            setValue('');
            return;
        }
        const num = parseInt(inputValue, 10);
        if (isNaN(num)) {
            return;
        }
        setValue(Math.max(min, Math.min(max, num)));
    };

    const handleFocus = () => {
        setIsFocused(true);
        if (value === min) {
            setValue('');
        }
    };

    const handleBlur = () => {
        setIsFocused(false);
        if (value === '' || isNaN(value)) {
            setValue(min);
        } else {
            setValue(Math.max(min, Math.min(max, parseInt(value, 10))));
        }
    };

    const handleWheel = (e) => {
        e.preventDefault();
        if (e.deltaY < 0) {
            handleIncrement();
        } else {
            handleDecrement();
        }
    };

    const handleConfirm = () => {
        const finalValue = value === '' || isNaN(value) ? min : Math.max(min, Math.min(max, parseInt(value, 10)));
        onConfirm(finalValue);
    };

    return (
        <div className={`choice-prompt-overlay ${isClosing ? 'closing' : ''}`}>
            <div id="choice-prompt-container" className={`choice-prompt ${isClosing ? 'closing' : ''}`}>
                <h3>{prompt}</h3>
                <div className="number-input-container">
                    <button className="number-input-button" onClick={handleDecrement}>−</button>
                    <input 
                        type="text"
                        inputMode="numeric"
                        value={value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        onWheel={handleWheel}
                        min={min}
                        max={max}
                        className="number-input-field"
                    />
                    <button className="number-input-button" onClick={handleIncrement}>+</button>
                </div>
                <div className="choice-options">
                    <button onClick={handleConfirm} className="choice-confirm-button">
                        {getUILoc('BUTTONS.CONFIRM')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NumberInput;
